import { useState } from 'react'

import styles from './styles.module.scss'
import { SeeInstitutionDetails } from './seeInstitution'
import { SeeCourses } from './seeCourses'
import { UpdateCourse } from './updateCourse'
import { SeeImages } from './seeImage'
import { AddCourse } from './addCourse'
import { Course } from '@/domain/entities/course.entity'
import { courseStore } from '@/stores/course.store'

export type TypeState =
  | 'INST'
  | 'CURSOS'
  | 'ADD CURSO'
  | 'EDIT CURSO'
  | 'VER IMAGENS'

export function InstitutionPage() {
  const [editingCurso, setEditingCurso] = useState({} as Course)
  const [state, setState] = useState<TypeState>('INST')

  const { courses } = courseStore()

  async function initEditarCurso(curso: Course) {
    setEditingCurso(curso)
    setState('EDIT CURSO')
  }

  const setStyles = (type: TypeState) =>
    state === type ? `${styles.button}` : undefined

  return (
    <div className={styles.main_container}>
      <div className={styles.buttons_container}>
        <button className={setStyles('INST')} onClick={() => setState('INST')}>
          Ver Instituição
        </button>
        <button
          className={setStyles('CURSOS')}
          onClick={() => setState('CURSOS')}
        >
          Ver Cursos
        </button>
        <button
          className={setStyles('ADD CURSO')}
          onClick={() => setState('ADD CURSO')}
        >
          Adicionar Curso
        </button>
        <button
          className={setStyles('VER IMAGENS')}
          onClick={() => setState('VER IMAGENS')}
        >
          Ver Imagens
        </button>
      </div>

      {state === 'INST' && <SeeInstitutionDetails />}

      {state == 'CURSOS' && <SeeCourses initEditarCurso={initEditarCurso} />}

      {state == 'EDIT CURSO' && (
        <UpdateCourse
          setState={setState}
          editingCurso={editingCurso}
          setEditingCurso={setEditingCurso}
        />
      )}

      {state == 'ADD CURSO' && (
        <AddCourse courses={courses} setState={setState} />
      )}

      {state == 'VER IMAGENS' && <SeeImages />}
    </div>
  )
}
